// Layout component - Converted from layout/default.vue
// Provides the main page wrapper structure
import React, { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="page-wrapper">
      {children}
    </div>
  );
};

export default Layout;
